import { FC, useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import { VendorHeader } from './VendorHeader';
import { AddVendorForm } from './AddVendorForm';
import { Loader, WarningPopup } from '../../../utils';
import '../../../css/fonts.css';
import '../../../css/all.min.css';
import '../../../css/style.css';
import './vendors-add.scss';
import '../../../scss/styles.scss';

export const AddVendorContent: FC<any> = ({
  getOtherVendorsList,
  clearAddVendor,
  onChangeVendorName,
  onChangeVendorDescription,
  onChangeVendorUrl,
  onChangeVendorAvatarImage,
  onAddVendor,
  getOtherVendor,
  onEditVendor,
  vendors,
  vendorForm,
  common,
}) => {
  const location: any = useLocation();
  const { spinner, redirectTo, isFormUpdated } = vendorForm;
  
  // declare state
  const [enableWarningAlert, setEnableWarningAlert] = useState(false);
  const [nav, setNav] = useState('none');
  
  // navigation hooks
  const navigate = useNavigate();
  const { id: idValue } = useParams<{ id: string }>();
  
  // get params
  const id = idValue ? idValue : vendorForm.id;
  const isAddMode = !idValue;
  const isEdit = !isAddMode;

  useEffect(() => {
    if (id) {
      // Convert string ID to number for the API call
      const numericId = parseInt(id, 10);
      if (!isNaN(numericId)) {
        getOtherVendor(numericId);
      }
    }
    // clear on unmount only
    return () => {
      clearAddVendor();
    };
  }, []);

  const handleClickOpen = () => {
    setEnableWarningAlert(true);
  };

  const handleClose = () => {
    setEnableWarningAlert(false);
  };

  const handleCancel = () => {
    setEnableWarningAlert(false);
    clearAddVendor();
    handleBackNavigation();
  };

  const handleBackNavigation = () => {
    navigate('/vendors/other-vendors');
  };

  const handleAddVendor = () => {
    
    // Basic validation
    if (!vendorForm.name?.trim()) {
      
      return;
    }

    const vendorData = {
      name: vendorForm.name.trim(),
      description: vendorForm.description?.trim() || '',
      vendor_url: vendorForm.vendor_url?.trim() || '',
      vendor_logo: vendorForm.avatarFile || undefined,
    };
    
   
    onAddVendor(vendorData);
  };

  const handleEditVendor = () => {
   
    // Basic validation
    if (!vendorForm.name?.trim()) {
      
      return;
    }

    const vendorData = {
      name: vendorForm.name.trim(),
      description: vendorForm.description?.trim() || '',
      vendor_url: vendorForm.vendor_url?.trim() || '',
      vendor_logo: vendorForm.avatarFile || undefined,
    };
    
   
    onEditVendor(vendorForm.id, vendorData);
  };

  if (redirectTo) {
    return <Navigate to="/vendors/other-vendors" />;
  }

  if (nav === 'goBack') {
    return <Navigate to="/vendors/other-vendors" />;
  }

  return (
    <div className="relative-wrapper">
      {spinner && (
        <div className="member-loader">
          <div className="document-loader">
            <Loader size={40} />
          </div>
        </div>
      )}
      <div>
        <VendorHeader
          isAddMode={isAddMode}
          handleGoBack={() =>
            !isFormUpdated
              ? handleBackNavigation()
              : handleClickOpen()
          }
        />
        <AddVendorForm
          vendorForm={vendorForm}
          onChangeVendorName={onChangeVendorName}
          onChangeVendorDescription={onChangeVendorDescription}
          onChangeVendorUrl={onChangeVendorUrl}
          onChangeVendorAvatarImage={onChangeVendorAvatarImage}
          onAddVendor={handleAddVendor}
          onEditVendor={handleEditVendor}
          isEdit={isEdit}
          isLoading={spinner}
          handleClickCancel={() =>
            !isFormUpdated
              ? handleBackNavigation()
              : handleClickOpen()
          }
        />

        {isFormUpdated && (
          <WarningPopup
            open={enableWarningAlert}
            type={'cancel'}
            handleProceed={handleCancel}
            handleClose={handleClose}
          />
        )}
      </div>
    </div>
  );
};
